import { createElement, lazy, Suspense, type ComponentType } from 'react';
import ChunkLoadErrorBoundary from './ChunkLoadErrorBoundary';
import PageLoadingFallback from './PageLoadingFallback';
import type { CreateLazyPageParams } from './types';

const createLazyPage = <PageProps extends object>({
    loadPage,
}: CreateLazyPageParams<PageProps>): ComponentType<PageProps> => {
    const LoadedPage = lazy(loadPage);

    const LazyPage = (pageProps: PageProps) => (
        <ChunkLoadErrorBoundary>
            <Suspense fallback={<PageLoadingFallback />}>
                {createElement(LoadedPage, pageProps)}
            </Suspense>
        </ChunkLoadErrorBoundary>
    );

    LazyPage.displayName = 'LazyPage';

    return LazyPage;
};

export default createLazyPage;
